import ApiService from "../../ApiService";

const HomeworkUnitService = {
    loadScreenView: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/mobile/homework/unit/loadscreenview", { searchVO }, successCallback, failureCallback);
    },
    zip: (homeworkId, successCallback, failureCallback) => {
        ApiService.post("/mobile/homework/unit/zip", { homeworkId }, successCallback, failureCallback);
    },
    zipAndDownloadHomeworkData: (homeworkId, successCallback, failureCallback) => {
        ApiService.post("/mobile/homework/unit/zipanddownloadhomeworkdata", { homeworkId, needToken: false }, successCallback, failureCallback);
    },
    downloadOfflineData: (userHomeworkId, successCallback, failureCallback) => {
        ApiService.post("/mobile/homework/unit/downloadhowework", { userHomeworkId, type: 0 }, successCallback, failureCallback);
    },
    getHomeworkUnitData: (homeworkUnitId, successCallback, failureCallback) => {
        ApiService.post("/mobile/homework/unit/gethomeworkunitdata", { id: homeworkUnitId }, successCallback, failureCallback);
    },
};

export default HomeworkUnitService;
